import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RecommendersPage from './components/RecommendersPage';
import RestaurantListPage from './components/RestaurantListPage';
import AllRestaurantsPage from './components/AllRestaurantsPage';
import RestaurantDetailPage from './components/RestaurantDetailPage';
import PlaceDetailPage from './components/PlaceDetailPage';
import NotFoundPage from './components/NotFoundPage';
import SignInPage from './components/SignInPage';
import SignUpPage from './components/SignUpPage';
import ForgotPasswordPage from './components/ForgotPasswordPage';
import ResetPasswordPage from './components/ResetPasswordPage';
import AccountPage from './components/AccountPage';
import MyListPage from './components/MyListPage';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';

const AppRoutes: React.FC = () => (
  <>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<AllRestaurantsPage />} />
      <Route path="/recommenders" element={<RecommendersPage />} />
      <Route path="/recommenders/:slug" element={<RestaurantListPage />} />
      <Route path="/restaurant/:slug" element={<RestaurantDetailPage />} />
      <Route path="/place/:placeId" element={<PlaceDetailPage />} />
      <Route path="/sign-in" element={<SignInPage />} />
      <Route path="/sign-up" element={<SignUpPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route
        path="/account"
        element={
          <ProtectedRoute>
            <AccountPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/my-list"
        element={
          <ProtectedRoute>
            <MyListPage />
          </ProtectedRoute>
        }
      />
      {/* Catch-all 404 route */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  </>
);

export default AppRoutes;
